<template>
	<div>
		<div class="img-div" :style="' background-image:url(' + popupVO.imgUrl + '); width:'
		+popupVO.sizeX+'px; height:'+popupVO.sizeY+'px; background-size: '+popupVO.sizeX +'px '+popupVO.sizeY+'px;'">

		<!-- 닫기버튼 -->
<!--		<div id="btn-close" style="width:50px; height:50px; left: ${ popup.closePositionX }; top: ${ popup.closePositionY }; "></div>-->

		<!-- 링크 버튼 -->
		<div id="btn-link"  @click="clickLink" :style="' width:'+popupVO.sizeX+'px; height:'+popupVO.sizeY+'px; '"></div>
			<div>
				<p id="pClose" style="position:absolute; right:0; bottom:0; z-index:2000; width: 100%; background-color: white; text-align: right; font-weight: 800; padding-right: 16px;" @click="clickClose">일주일 동안 보이지 않기 [X] &nbsp;&nbsp;&nbsp;&nbsp;</p>
			</div>

		</div>
	</div>
</template>

<script>
export default {
	name: "popupOpen",
	data() {
		var idx = this.$route.params.idx;
		return {
			idx,
			popupVO : {},
		}
	},
	updated() {

	},
	created() {
		this.getPopupInfo();

	},
	mounted() {

	},
	methods: {
		getPopupInfo(){
			const self = this;

			this.axiosCaller.get( this, this.APIs.DISPLAY_POPUP + "/", {
				idx: self.$route.params.idx
			}, (res) => {
				console.log('res', res)
				self.popupVO = res.data
				// window.resizeTo( self.popupVO.sizeX, self.popupVO.sizeY);
			})
		},

		clickLink() {
			// window.opener.location = this.popupVO.url;
			// console.log('this.popupVO.url',this.popupVO.url)

			this.appClose({
				url: this.popupVO.url,
			});
		},

		clickClose() {
			this.setCookie( "popup_" + this.idx, "done", 7 );
			this.appClose({});
		},

		setCookie(name, value, expiredays) {
			var todayDate = new Date();
			todayDate.setDate(todayDate.getDate() + expiredays);
			todayDate.setHours(0);
			todayDate.setMinutes(0);
			todayDate.setSeconds(0);
			document.cookie = name + "=" + escape(value) + "; path=/; expires=" + todayDate.toGMTString() + ";"
		},

	}
}
</script>

<style scoped>

	div #btn-link {
		cursor : pointer;
		position: absolute;
		z-index: 1000;
	}

	p{
		vertical-align:baseline;
		font-family:NanumGothic,'Malgun Gothic','Dotum','돋움','Tahoma','sans-serif';
		cursor : pointer;
		font-size:14px;
		letter-spacing:-1px;
		padding:0;
		margin:0;
		border:none;
		line-height:20px;
	}

	.img-div{
		border: 0px;
		padding: 0px;
		margin: 0px;
		background: no-repeat;
		/*cursor : pointer;*/
		position: absolute;
		z-index: 100;
	}

</style>

